module.exports = {"total_service_charges":"Total Charges"};